<template>
  <div class="form-group">
    <label class="form-control-label" :for="'input-text-' + this._uid" v-if="!hideLabel">
      <slot></slot> <span v-if="required" class="required" data-toggle="tooltip" data-placement="bottom" title="Required">*</span>
    </label>
    <input class="form-control"
      :type="type ? type : 'text'"
      :id="'input-text-' + this._uid"
      ref="input"
      :value="value"
      v-on:input="updateValue($event.target.value)"
      :disabled="disabled"
      :maxlength="maxlength"
      :min="min"
      :max="max"
      :class="{ 'is-invalid': error }"
      :placeholder="placeholder">
    <small v-if="helpText" class="form-text text-muted">{{helpText}}</small>
    <div v-if="error" class="invalid-feedback">{{ error.message }}</div>
  </div>
</template>
<script>
export default {
  name: "vue-ez-input",
  props: [
    "value",
    "error",
    "helpText",
    "required",
    "type",
    "disabled",
    "maxlength",
    "min",
    "max",
    "placeholder",
    "returnArray",
    "hideLabel"
  ],
  mounted() {
    /* eslint-disable no-undef */
    $('[data-toggle="tooltip"]').tooltip();
  },
  methods: {
    updateValue: function(value) {
      let v = value;
      if (this.returnArray) {
        if (v === "") {
          v = [];
        } else {
          v = v.split(/\s*,\s*/);
        }
      }
      this.$emit("input", v);
    }
  }
};
</script>
